import React from 'react';
import { Outlet } from 'react-router-dom';
import { MembershipStatusBanner } from '@/components/ui/organisms/MembershipStatusBanner';

interface BaseLayoutProps {
  title?: string;
  showTitle?: boolean;
  children?: React.ReactNode;
}

/**
 * BaseLayout: Used for 3rd Level Screens.
 * Renders main content with optional title
 */
const BaseLayout: React.FC<BaseLayoutProps> = ({ title, showTitle = false, children }) => {
  return (
    <div className="flex flex-col h-[100dvh]">
      {showTitle && title && (
        <div className="flex items-center justify-center px-5 pt-5 pb-4 pt-[calc(20px+env(safe-area-inset-top))]">
          <h1 className="text-[24px] font-semibold text-[#111215] leading-[28px] text-center">
            {title}
          </h1>
        </div>
      )}
      <MembershipStatusBanner />
      <main className="flex-1 overflow-y-auto overflow-x-hidden">
        {children ? children : <Outlet />}
      </main>
    </div>
  );
};

export default BaseLayout;
